import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";

import { ButtonNew, IconButton } from "..";
import { columnsAPINamesEnums } from "../../enums/AssetOverview/portfolio";
import { AssetDetailedCard } from "../BuildingProfile/AssetDetailedCard";
import { CustomModal } from "../CustomModal";

export const AssetCardModal = ({ assetCardPosition, building, onCardClick, onClose, triggerFlag }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (building) setModalOpen(true);
  }, [triggerFlag]);

  const assetCardConfig = [
    [
      { dataKey: columnsAPINamesEnums.BUILDING_NAME, label: "ASSET NAME" },
      { dataKey: columnsAPINamesEnums.USE_TYPE, label: "TYPE" },
      { dataKey: columnsAPINamesEnums.FULL_ADDRESS, label: "ADDRESS" },
      { dataKey: columnsAPINamesEnums.GROSS_AREA_WITH_BASEMENT, label: "GROSS ASSET SIZE" },
    ],
    [
      { dataKey: columnsAPINamesEnums.YEAR_OF_CONSTRUCTION, label: "YEAR OF CONSTRUCTION" },
      { dataKey: columnsAPINamesEnums.STRANDING_YEAR, label: "STRANDING YEAR" },
      { dataKey: columnsAPINamesEnums.ENERGY_EFFICIENCY_CLASS, label: "EPC CLASS" },
      { dataKey: columnsAPINamesEnums.CO2_EMISSION, label: "CO2 EMISSIONS" },
      { dataKey: columnsAPINamesEnums.TOTAL_ENERGY_CONSUMPTION, label: "ENERGY CONSUMPTION" },
    ],
  ];
  return (
    <Draggable>
      <CustomModal
        closeIcon={false}
        disableBackdropClick
        disableEnforceFocus
        disableScrollLock
        height={0}
        hideBackdrop
        modalOpen={modalOpen}
        onClose={undefined}
        padding={0}
        setModalOpen={setModalOpen}
        slotProps={{
          backdrop: {
            sx: {
              display: "none",
            },
          },
          root: {
            sx: {
              bottom: "unset",
              left: "unset",
              right: 0,
              top: "60px",
              zIndex: 2000,
            },
          },
        }}
        style={{
          bottom: "unset",
          height: "fit-content",
          left: assetCardPosition?.x || 50,
          marginRight: "1.6rem",
          paddingBottom: "4rem",
          position: "fixed",
          top: assetCardPosition?.y || 50,
          transform: "none",
        }}
        width={600}
      >
        {/* TODO: WRONG */}
        <Stack className="h-6 cursor-grab bg-lds-selection-subtle pr-2" flexDirection="row-reverse">
          <IconButton
            buttonProps={{
              onClick: () => {
                setModalOpen(false);
                onClose();
              },
              variant: "tertiary",
            }}
            iconProps={{ iconName: "Close" }}
          />
        </Stack>
        <div className="group">
          <div className="absolute inset-0 top-25 z-50  cursor-grab " />
          <AssetDetailedCard
            building={building}
            buildingType={building?.[columnsAPINamesEnums.USE_TYPE]}
            className="w-full p-3  text-left"
            config={assetCardConfig}
            imageClassName="h-50 w-full cursor-auto object-cover"
            imgPath={building?.[columnsAPINamesEnums.IMAGE_URL_VALUE]}
            upload={false}
          />
        </div>
        <ButtonNew
          className="absolute inset-x-3 bottom-3 z-50 h-0 items-center  justify-center overflow-hidden  transition-all duration-100  group-hover:h-12 group-hover:cursor-pointer"
          onClick={onCardClick}
          size="lg"
          variant="primary"
        >
          + {t("general.openInNewTab")}
        </ButtonNew>
      </CustomModal>
    </Draggable>
  );
};
